import { all, call, put, takeLatest } from 'redux-saga/effects';

import { request } from '@app/services';
import * as actions from './slice';
import * as endpoints from './endpoints';
import { getInternDetailsSuccess } from '../intern/slice';

function* getEmployeesSaga(action: ReturnType<typeof actions.getEmployees>): any {
  try {
    const result = yield call(request.get, endpoints.employees);
    yield put(actions.getEmployeesSuccess(result.data));
  } catch (err) {
    yield put(actions.getEmployeesFailed(err));
  }
}

function* addEmployeeSaga(action: ReturnType<typeof actions.addEmployee>): any {
  try {
    const {
      personalInfo,
      officialInfo,
      educationInfo,
      bankInfo,
      emergencyContactInfo,
      workExperienceInfo,
      documentInfo,
      source,
      resume,
      referenceBy,
      other,
    } = action.payload;
    const formData = new FormData();
    formData.append('firstName', personalInfo.firstName);
    formData.append('lastName', personalInfo.lastName);
    formData.append('phone', personalInfo.phone);
    formData.append('profileImage', personalInfo.employeeImage);
    const { presentAddress, permanentAddress } = personalInfo;

    if (
      presentAddress?.address &&
      presentAddress.city &&
      presentAddress.country &&
      presentAddress.postalCode &&
      presentAddress.state
    ) {
      formData.append('presentAddress', JSON.stringify(presentAddress));
    }

    if (
      permanentAddress?.address &&
      permanentAddress.city &&
      permanentAddress.country &&
      permanentAddress.postalCode &&
      permanentAddress.state
    ) {
      formData.append('permanentAddress', JSON.stringify(permanentAddress));
    }
    if (personalInfo.dob) {
      formData.append('dob', personalInfo.dob);
    }
    formData.append('source', source);
    formData.append('referenceBy', referenceBy);
    formData.append('other', other);
    formData.append('resume', personalInfo.resume);
    formData.append('gender', personalInfo.gender);
    formData.append('maritalStatus', personalInfo.maritalStatus);
    formData.append('aboutMe', personalInfo.aboutMe);
    formData.append('personalEmail', personalInfo.personalEmail);
    formData.append('email', officialInfo.officialEmail);
    formData.append('joiningDate', officialInfo.joiningDate);
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    formData.append('roleId', `${officialInfo.roleId}`);
    officialInfo.managerId.forEach((id: any, index: any) => {
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      formData.append(`managerId[${index}]`, `${id}`);
    });

    formData.append('designation', officialInfo.designation);
    formData.append('department', officialInfo.department);
    formData.append(`education`, JSON.stringify(educationInfo.education));
    formData.append(`workExperience`, JSON.stringify(workExperienceInfo.workExperience));

    if (bankInfo.bankInformation) {
      formData.append('bankInformation', JSON.stringify(bankInfo.bankInformation));
    }
    formData.append(`emergencyContact`, JSON.stringify(emergencyContactInfo.emergencyContact));

    formData.append('aadharFront', documentInfo.aadharFront);
    formData.append('aadharBack', documentInfo.aadharBack);
    formData.append('panFront', documentInfo.panFront);
    formData.append('panBack', documentInfo.panBack);
    formData.append('resume', resume);

    const result = yield call(request.post, endpoints.addEmployee, formData);
    yield put(actions.addEmployeeSuccess(result.data));
  } catch (err) {
    yield put(actions.addEmployeeFailed(err));
  }
}

//
function* updateEmployeeStatusSaga(action: ReturnType<typeof actions.updateEmployeeStatus>): any {
  try {
    const { row, reason, status } = action.payload;
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    const result = yield call(request.put, `${endpoints.updateEmployeeStatus}${row.id}`, {
      status,
      reason,
    });
    yield put(actions.updateEmployeeStatusSuccess(result.data));
  } catch (err) {
    yield put(actions.updateEmployeeStatusFailed(err));
  }
}
function* updateEmployeeSaga(action: ReturnType<typeof actions.updateEmployee>): any {
  try {
    const {
      id,
      personalInfo,
      officialInfo,
      educationInfo,
      emergencyContactInfo,
      bankInfo,
      workExperienceInfo,
      documentInfo,
      resume,
      source,
      referenceBy,
      samePresentAddress,
      other,
    } = action.payload;
    const formData = new FormData();
    formData.append('firstName', personalInfo.firstName);
    formData.append('lastName', personalInfo.lastName);
    formData.append('phone', personalInfo.phone);
    if (typeof personalInfo.employeeImage === 'object') {
      formData.append('profileImage', personalInfo.employeeImage);
    }
    const { presentAddress, permanentAddress } = personalInfo;

    if (
      presentAddress?.address &&
      presentAddress.city &&
      presentAddress.country &&
      presentAddress.postalCode &&
      presentAddress.state
    ) {
      formData.append('presentAddress', JSON.stringify(presentAddress));
    }

    if (
      permanentAddress?.address &&
      permanentAddress.city &&
      permanentAddress.country &&
      permanentAddress.postalCode &&
      permanentAddress.state
    ) {
      formData.append('permanentAddress', JSON.stringify(permanentAddress));
    }
    if (personalInfo.dob) {
      formData.append('dob', personalInfo.dob);
    }
    formData.append('gender', personalInfo.gender);
    formData.append('maritalStatus', personalInfo.maritalStatus);
    formData.append('aboutMe', personalInfo.aboutMe);
    formData.append('personalEmail', personalInfo.personalEmail);
    formData.append('email', officialInfo.officialEmail);
    formData.append('joiningDate', officialInfo.joiningDate);
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    formData.append('roleId', `${officialInfo.roleId}`);
    officialInfo.managerId.forEach((id: any, index: any) => {
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      formData.append(`managerId[${index}]`, `${id}`);
    });

    formData.append('designation', officialInfo.designation);
    formData.append('department', officialInfo.department);
    formData.append(`education`, JSON.stringify(educationInfo.education));
    formData.append(`workExperience`, JSON.stringify(workExperienceInfo.workExperience));

    if (bankInfo.bankInformation) {
      formData.append('bankInformation', JSON.stringify(bankInfo.bankInformation));
    }
    formData.append(`emergencyContact`, JSON.stringify(emergencyContactInfo.emergencyContact));
    if (typeof documentInfo.aadharFront === 'object') {
      formData.append('aadharFront', documentInfo.aadharFront);
    }
    if (typeof documentInfo.aadharBack === 'object') {
      formData.append('aadharBack', documentInfo.aadharBack);
    }
    if (typeof documentInfo.panFront === 'object') {
      formData.append('panFront', documentInfo.panFront);
    }
    if (typeof documentInfo.panBack === 'object') {
      formData.append('panBack', documentInfo.panBack);
    }
    formData.append('resume', resume);
    formData.append('source', source);
    formData.append('referenceBy', referenceBy);
    formData.append('other', other);
    formData.append('samePresentAddress', samePresentAddress);

    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    const result = yield call(request.put, `${endpoints.updateEmployee}${id}`, formData);
    yield put(actions.updateEmployeeSuccess(result.data));
    yield put(actions.getEmployeeDetails(id));
    if (result.data.roleId === 3) {
      yield put(getInternDetailsSuccess(result.data));
    }
  } catch (err) {
    yield put(actions.updateEmployeeFailed(err));
  }
}
function* getEmployeeDetailsSaga(action: ReturnType<typeof actions.getEmployeeDetails>): any {
  try {
    const employeeId = action.payload;
    // eslint-disable-next-line @typescript-eslint/no-base-to-string, @typescript-eslint/restrict-template-expressions
    const result = yield call(request.get, `${endpoints.getEmployeeDetails}${employeeId}`);
    yield put(actions.getEmployeeDetailsSuccess(result.data));
  } catch (err) {
    yield put(actions.getEmployeeDetailsFailed(err));
  }
}
//
function* getEmployeeActivityByIdSaga(
  action: ReturnType<typeof actions.getEmployeeActivityById>
): any {
  try {
    const employeeId = action.payload;
    // eslint-disable-next-line @typescript-eslint/no-base-to-string, @typescript-eslint/restrict-template-expressions
    const result = yield call(request.get, `${endpoints.getEmployeeActivity}${employeeId}`);
    yield put(actions.getEmployeeActivityByIdSuccess(result.data));
  } catch (err) {
    yield put(actions.getEmployeeActivityByIdFailed(err));
  }
}
//
function* getEmployeesInternsSearchSaga(
  action: ReturnType<typeof actions.getEmployeesInternsSearch>
): any {
  try {
    const q = action.payload;
    const result = yield call(request.get, endpoints.searchEmployeesInterns, {
      params: {
        q,
      },
    });
    yield put(actions.getEmployeesInternsSearchSuccess(result.data));
  } catch (err) {
    yield put(actions.getEmployeesInternsSearchFailed(err));
  }
}

function* employeeSagas() {
  yield all([
    takeLatest(
      [
        actions.getEmployees,
        actions.addEmployeeSuccess,
        actions.updateEmployeeSuccess,
        actions.updateEmployeeStatusSuccess,
      ],
      getEmployeesSaga
    ),
    takeLatest(actions.addEmployee, addEmployeeSaga),
    takeLatest(actions.updateEmployeeStatus, updateEmployeeStatusSaga),
    takeLatest(actions.updateEmployee, updateEmployeeSaga),
    takeLatest(actions.getEmployeeDetails, getEmployeeDetailsSaga),
    takeLatest(actions.getEmployeeActivityById, getEmployeeActivityByIdSaga),
    takeLatest(actions.getEmployeesInternsSearch, getEmployeesInternsSearchSaga),
  ]);
}

export { employeeSagas };
